import { Link } from "react-router-dom";

const LandingFooter = () => {
  return (
    <footer className="section landing-footer">
      <div className="contents">
        All rights reserved by Landknock Ltd. |{" "}
        <Link to="/privacy-policy">Privacy Policy</Link> |{" "}
        <Link to="/delivery-policy">Delivery Policy</Link>
      </div>
    </footer>
  );
};

export default LandingFooter;
